import type { BranchClientLogo } from '@/lib/branch-client-logo'

export function prepareInlineEmailImage(body: string, inlineImage?: BranchClientLogo) {
  const shouldAttach = !!inlineImage && body.includes(inlineImage.dataUrl)
  return {
    body: shouldAttach ? body.replaceAll(inlineImage.dataUrl, `cid:${inlineImage.contentId}`) : body,
    inlineImage: shouldAttach ? inlineImage : undefined,
  }
}

export function generateDefaultSignature(senderName?: string | null, branchLogoUrl?: string): string {
  const name = senderName || 'The Daisy Team'
  const logoUrl = branchLogoUrl || `${window.location.origin}/daisy-logo-sunrise-deepsea.png`
  return `<p>Best regards,</p>
<p>${name}</p>
<p></p>
<p><img src="${logoUrl}" alt="Daisy" style="max-width: 150px; width: auto; height: auto;" /></p>`
}

export function generateEmailTemplate(
  contactName: string,
  quoteName: string,
  proposalUrl: string,
  emailSignature?: string | null,
  senderName?: string | null,
  isService?: boolean,
  requiresSignature?: boolean,
  branchLogoUrl?: string
) {
  const firstName = contactName?.split(' ')[0] || 'there'
  const signOff = emailSignature || generateDefaultSignature(senderName, branchLogoUrl)
  const documentName = isService ? 'invoice' : 'proposal'
  const linkText = `${requiresSignature ? 'Review and sign' : 'View'} ${documentName}`

  if (isService) {
    return `<p>Hi ${firstName},</p>
<p></p>
<p>${requiresSignature ? 'Please review and sign' : 'Please find'} your service invoice for <strong>${quoteName}</strong>.</p>
<p></p>
<p>${requiresSignature ? 'Your signature is required to approve the service invoice. Use the link below to review the details and complete your signature:' : 'Click the link below to view your invoice:'}</p>
<p><a href="${proposalUrl}" target="_blank" rel="noopener noreferrer">${linkText}</a></p>
<p></p>
<p>If you have any questions, please don't hesitate to reach out.</p>
<p></p>
${signOff}`
  }

  return `<p>Hi ${firstName},</p>
<p></p>
<p>Thank you for the opportunity to work with you on your project! We're excited to share your proposal for <strong>${quoteName}</strong>.</p>
<p></p>
<p>${requiresSignature ? 'Please use the link below to review the proposal and complete your signature. Your signature confirms your approval and allows us to move forward.' : 'Please click the link below to view your proposal:'}</p>
<p><a href="${proposalUrl}" target="_blank" rel="noopener noreferrer">${linkText}</a></p>
<p></p>
<p>If you have any questions or would like to discuss any details, please don't hesitate to reach out.</p>
<p></p>
${signOff}`
}
